import { NavLink, useLocation } from "react-router";
import { Icon, type IconName } from "./icons";

const TABS: { to: string; label: string; icon: IconName; match: (p: string) => boolean }[] = [
  { to: "/", label: "Overview", icon: "overview", match: (p) => p === "/" },
  { to: "/accounts", label: "Accounts", icon: "accounts", match: (p) => p.startsWith("/accounts") },
  { to: "/portals", label: "Portals", icon: "portals", match: (p) => p.startsWith("/portals") || p === "/connect" },
  { to: "/audit", label: "Audit", icon: "audit", match: (p) => p === "/audit" },
];

/**
 * The phone's navigation: the four places an administrator goes most, under
 * the thumb, and More for the rest of the sidebar. Hidden on wide screens,
 * where the sidebar is always there.
 */
export function Dock({ open, onMore }: { open: boolean; onMore: () => void }) {
  const { pathname } = useLocation();
  const inMore = !TABS.some((t) => t.match(pathname));
  return (
    <nav className="dock" aria-label="Sections">
      {TABS.map((t) => (
        <NavLink key={t.to} to={t.to} className="dock-tab" data-active={t.match(pathname) || undefined} aria-current={pathname === t.to ? "page" : undefined}>
          <Icon name={t.icon} size={20} />
          <span>{t.label}</span>
        </NavLink>
      ))}
      <button type="button" className="dock-tab" data-active={inMore || open || undefined} aria-expanded={open} aria-controls="ops-sidebar" onClick={onMore}>
        <Icon name="menu" size={20} />
        <span>More</span>
      </button>
    </nav>
  );
}
